import axios from "axios";

export const getBillingCategoriesAndClasses = function () {
    return axios.get("/WebUI/GlobalServices/BillingCategoriesAndClasses").then(function (response) {
        return response;
    });
};
export const createBillingManagerCharge = function (payload) {
    return axios.post("/WebUI/Customers/Charges/BillingManagerCharge", { data: payload }).then(function (response) {
        return response;
    });
};
export const getPredefinedManualRates = function (customerId, facilityId) {
    return axios
        .get(`/WebUI/Inventory/Adjustments/PredefinedManualRates?customerId=${customerId}&facilityId=${facilityId}`)
        .then(function (response) {
            return response;
        });
};
